import { CircleInfoIcon } from 'assets/icons';
import React from 'react';
import styled from 'styled-components/macro';
import { BannerType } from './enums/BannerType';

interface AlertBannerProps {
  type: BannerType;
  className?: string;
}

const AlertBanner: React.FC<AlertBannerProps> = ({ type, children, className }) => {
  switch (type) {
    case BannerType.Info:
      return (
        <InfoBanner className={className}>
          <StyledCircleInfoIcon />
          <TextContainer>{children}</TextContainer>
        </InfoBanner>
      );

    default:
      return <div>{children}</div>;
  }
};

export default AlertBanner;

const Banner = styled.div`
  padding: 1rem;
  display: flex;
  align-items: center;
`;

const TextContainer = styled.div`
  padding-left: 1rem;
`;

const InfoBanner = styled(Banner)`
  border: solid 1px #edc308;
  background-color: #fcf4d3;
  color: #1e2477;
`;

const StyledCircleInfoIcon = styled(CircleInfoIcon)`
  height: 1rem;
  width: 2rem;
`;
